import * as React from "react";

import { Route } from "react-router";

import App from "./App";
import { NotFoundPage } from "./components/NotFoundPage/NotFoundPage";
import { withAuth } from "./utils/withAuth";

/**
 * Add lazy loaded routes here to leverage code splitting.
 * Use a default export in the imported module to keep the imports more concise.
 */
const AttendeeAddDetailsPageMain = React.lazy(() =>
  import("@/features/invites/pages/AttendeeAddDetailsPageMain").then(
    (module) => ({
      default: module.AttendeeAddDetailsPageMain,
    }),
  ),
);
const AttendeeSendInvitePageMain = React.lazy(() =>
  import("@/features/invites/pages/AttendeeSendInvitePageMain").then(
    (module) => ({
      default: module.AttendeeSendInvitePageMain,
    }),
  ),
);

const OfferFlowPage = React.lazy(() =>
  import("@/features/custom-offer/OfferFlow").then((module) => ({
    default: module.OfferFlowPage,
  })),
);

const ErrorPage = React.lazy(() => import("@/features/error/ErrorPage"));

const ReviewPage = React.lazy(() => import("@/features/reviews/ReviewPage"));

const InviteContainer = React.lazy(() =>
  import("@/features/invites/pages/InviteContainer").then((module) => ({
    default: module.InviteContainer,
  })),
);

const OnboardingPage = React.lazy(() => import("@/features/onboarding"));
const OnboardingTurnaround = React.lazy(
  () => import("@/features/onboarding/OnboardingTurnaround"),
);

const PasswordResetPage = React.lazy(
  () => import("@/features/auth/pages/PasswordReset/PasswordResetPage"),
);
const PasswordChangePage = React.lazy(
  () => import("@/features/auth/pages/PasswordChange/PasswordChangePage"),
);

const ReviewOfferPage = React.lazy(
  () => import("@/features/custom-offer/ReviewOfferPage/ReviewOfferPage"),
);

const SigninPage = React.lazy(() => import("@/features/auth/pages/Signin"));

const SignupPage = React.lazy(() => import("@/features/auth/pages/Signup"));

const InquiryPage = React.lazy(() =>
  import("@/features/inquiry").then((module) => ({
    default: module.InquiryPage,
  })),
);

const ReviewOveragesPage = React.lazy(() =>
  import("@/features/overages").then((module) => ({
    default: module.ReviewOveragesPage,
  })),
);

/**
 * NOTE: When you add a new route to this file, make sure fe-lb contains an entry that redirects it to web-2, and that the route is handled in the web-2 express server (server.js)
 */
export default (
  <Route path="/" component={App}>
    <Route path="(:urlPrefix/)invite" component={InviteContainer}>
      <Route
        path="send/:bookingId"
        component={withAuth(AttendeeSendInvitePageMain)}
      />
      <Route
        path="add/:bookingId"
        component={withAuth(AttendeeAddDetailsPageMain)}
      />
    </Route>

    <Route
      component={withAuth(ReviewOfferPage)}
      path="inbox/:bookingId/review-offer"
    />
    <Route
      component={withAuth(OfferFlowPage)}
      path="inbox/:id/offer-custom-price"
    />
    <Route component={withAuth(OfferFlowPage)} path="inbox/:id/edit-offer" />
    <Route
      component={withAuth(OfferFlowPage)}
      path="inbox/:id/host-update-booking"
    />
    <Route path="(:urlPrefix/)error" component={ErrorPage} />
    <Route component={withAuth(InquiryPage)} path="inquiry/:listingId" />
    <Route
      component={withAuth(ReviewOveragesPage)}
      path="inbox/:bookingId/review-overages"
    />
    <Route
      component={withAuth(OfferFlowPage)}
      path="inbox/:id/guest-update-booking-new"
    />

    <Route
      path="onboarding/turnaround"
      component={withAuth(OnboardingTurnaround)}
    />

    <Route path="onboarding" component={withAuth(OnboardingPage)} />

    <Route component={withAuth(ReviewPage)} path="review/space/:reviewId" />
    <Route path="(:urlPrefix/)password-change" component={PasswordChangePage} />
    <Route path="(:urlPrefix/)password-reset" component={PasswordResetPage} />
    <Route path="(:urlPrefix/)signin" component={SigninPage} />
    <Route path="(:urlPrefix/)signup" component={SignupPage} />

    <Route path="*" component={NotFoundPage} />
  </Route>
);
